module.exports = __webpack_public_path__ + "static/media/computer_operator.bb86735f.svg";